module.exports = __webpack_public_path__ + "img/p9.f360ebbd.png";